"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _layout = _interopRequireDefault(require("antd/lib/layout"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _typography = _interopRequireDefault(require("antd/lib/typography"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _Header = _interopRequireDefault(require("../components/header/Header"));

var _StudySideBar = _interopRequireDefault(require("../components/sidebar/StudySideBar"));

var _StudyNotFound = _interopRequireDefault(require("../pages/404/StudyNotFound"));

var _AnalyticsReport = _interopRequireDefault(require("../pages/reports/AnalyticsReport"));

var _IncentivesReport = _interopRequireDefault(require("../pages/reports/IncentivesReport"));

var _ActivitiesLandingPage = _interopRequireDefault(require("../pages/study/activity/ActivitiesLandingPage"));

var _AdHocQueryLandingPage = _interopRequireDefault(require("../pages/study/adHocQuery/AdHocQueryLandingPage"));

var _ArmsPage = _interopRequireDefault(require("../pages/study/arm/ArmsPage"));

var _DashboardLandingPage = _interopRequireDefault(require("../pages/study/dashboard/DashboardLandingPage"));

var _Form = _interopRequireDefault(require("../pages/study/form/Form"));

var _ForumPage = _interopRequireDefault(require("../components/forum/ForumPage"));

var _Study = _interopRequireDefault(require("../pages/study/home/Study"));

var _PaymentsLandingPage = _interopRequireDefault(require("../pages/study/payment/PaymentsLandingPage"));

var _Participant = _interopRequireDefault(require("../pages/study/participant/detail/Participant"));

var _ParticipantSearch = _interopRequireDefault(require("../pages/study/participant/search/ParticipantSearch"));

var _ResourceEditPage = _interopRequireDefault(require("../pages/study/resource/ResourceEditPage"));

var _ResourcesLandingPage = _interopRequireDefault(require("../pages/study/resource/ResourcesLandingPage"));

var _SettingsLandingPage = _interopRequireDefault(require("../pages/study/settings/SettingsLandingPage"));

var _SurveysLandingPage = _interopRequireDefault(require("../pages/study/survey/SurveysLandingPage"));

var _TestKitsLandingPage = _interopRequireDefault(require("../pages/study/testkit/TestKitsLandingPage"));

var _topic = require("../redux/topics/topic.types");

var selectors = _interopRequireWildcard(require("../redux/selectors"));

var _study = require("../redux/study/study.types");

var _Avatars = _interopRequireDefault(require("../components/avatar/Avatars"));

var _Inbox = _interopRequireDefault(require("../pages/study/inbox/Inbox"));

var _AnnouncementLandingPage = _interopRequireDefault(require("../pages/study/announcement/AnnouncementLandingPage"));

var _QnaLandingPage = _interopRequireDefault(require("../pages/study/qna/QnaLandingPage"));

var _UserCreationPage = _interopRequireDefault(require("../pages/study/user/UserCreationPage"));

var _GoalSettingLandingPage = _interopRequireDefault(require("../pages/study/goalSetting/GoalSettingLandingPage"));

var _BadgesLandingPage = _interopRequireDefault(require("../components/badge/BadgesLandingPage"));

var _AdminManagementLandingPage = _interopRequireDefault(require("../pages/study/admin/AdminManagementLandingPage"));

var _AppointmentAvailabilityLandingPage = _interopRequireDefault(require("../pages/study/appointment/AppointmentAvailabilityLandingPage"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Content,
  Footer
} = _layout.default;
const {
  Title
} = _typography.default;

class StudyRouter extends _react.Component {
  componentDidMount() {
    const {
      loadStudy,
      loadForumTopics,
      requestedStudyId
    } = this.props;
    loadStudy(requestedStudyId);
  }

  render() {
    const {
      requestedStudyId,
      study,
      status,
      isNonYAB,
      hasDataAnalystRole,
      hasStudyManagerRole,
      showSurveys,
      showForms,
      showGoals,
      showIncentives,
      showTestKits,
      showAppointmentAvailability,
      showAppointments
    } = this.props; // TODO componentize the Spinner and Error Message

    if (status.isLoading) {
      return /*#__PURE__*/_react.default.createElement(_layout.default, {
        id: "main"
      }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(Content, {
        id: "content"
      }, /*#__PURE__*/_react.default.createElement(_spin.default, {
        size: "large"
      })));
    }

    if (status.isError) {
      return /*#__PURE__*/_react.default.createElement(_layout.default, {
        id: "main"
      }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(Content, {
        id: "content"
      }, "Error: ", status.errorMessage));
    }

    if (requestedStudyId === -1) {
      return /*#__PURE__*/_react.default.createElement(_layout.default, {
        id: "main"
      }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(Content, {
        id: "content"
      }, "An invalid or unknown Study ID was specified in the URL."));
    }

    if (!study) {
      return /*#__PURE__*/_react.default.createElement(_layout.default, {
        id: "main"
      }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(Content, {
        id: "content"
      }, "The Study could not be loaded."));
    }

    const fullPrivilegeRoutes = [];
    const dataAnalystRoutes = [];

    if (isNonYAB) {
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "dashboard",
        exact: true,
        path: "/study/:studyId",
        component: _DashboardLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "study",
        exact: true,
        path: "/study/:studyId/study",
        component: _Study.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "activities",
        exact: true,
        path: "/study/:studyId/activities",
        component: _ActivitiesLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "announcements",
        exact: true,
        path: "/study/:studyId/announcements",
        component: _AnnouncementLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "arms",
        exact: true,
        path: "/study/:studyId/arms",
        component: _ArmsPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "avatars",
        exact: true,
        path: "/study/:studyId/avatars",
        component: _Avatars.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "badges",
        path: "/study/:studyId/badges",
        component: _BadgesLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "inbox",
        exact: true,
        path: "/study/:studyId/inbox",
        component: _Inbox.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "participants",
        exact: true,
        path: "/study/:studyId/participants",
        component: _ParticipantSearch.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "participant",
        path: "/study/:studyId/participants/:participantId",
        component: _Participant.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "qna",
        exact: true,
        path: "/study/:studyId/qna",
        component: _QnaLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "resources",
        exact: true,
        path: "/study/:studyId/resources",
        component: _ResourcesLandingPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "newResource",
        exact: true,
        path: "/study/:studyId/resources/new",
        component: _ResourceEditPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "editResource",
        exact: true,
        path: "/study/:studyId/resources/edit/:articleId",
        component: _ResourceEditPage.default
      }));
      fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "user creation",
        exact: true,
        path: "/study/:studyId/user",
        component: _UserCreationPage.default
      }));

      if (hasStudyManagerRole) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "admin",
          exact: true,
          path: "/study/:studyId/admin",
          component: _AdminManagementLandingPage.default
        }));
      }

      if (showAppointments) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "appointments",
          path: "/study/:studyId/appointments",
          component: _AppointmentAvailabilityLandingPage.default
        })); // fullPrivilegeRoutes.push(<Route key="viewAppointment" exact path="/study/:studyId/appointments/appointment/:appointmentId" component={AppointmentLandingPage} />);
        // if (showAppointmentAvailability) {
        //   fullPrivilegeRoutes.push( <Route key="viewAppointment" exact path="/study/:studyId/appointments/availability/:availabilityId" component={AppointmentAvailabilityLandingPage}/> );
        // }
        // else {
        // }
      }

      if (showGoals) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "goals",
          exact: true,
          path: "/study/:studyId/goals",
          component: _GoalSettingLandingPage.default
        }));
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "viewGoal",
          exact: true,
          path: "/study/:studyId/goals/:goalId",
          component: _GoalSettingLandingPage.default
        }));
      }

      if (showForms) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "forms",
          exact: true,
          path: "/study/:studyId/form",
          component: _Form.default
        }));
      }

      if (showIncentives) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "payments",
          exact: true,
          path: "/study/:studyId/payments",
          component: _PaymentsLandingPage.default
        }));
      }

      if (showSurveys) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "surveys",
          exact: true,
          path: "/study/:studyId/surveys",
          component: _SurveysLandingPage.default
        }));
      }

      if (showTestKits) {
        fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "testkits",
          path: "/study/:studyId/testkits",
          component: _TestKitsLandingPage.default
        }));
      }
    }

    if (hasDataAnalystRole) {
      if (showIncentives) {
        dataAnalystRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "incentives_report",
          exact: true,
          path: "/study/:studyId/reports/incentives",
          component: _IncentivesReport.default
        }));
      }

      dataAnalystRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "analytics_report",
        exact: true,
        path: "/study/:studyId/reports/analytics",
        component: _AnalyticsReport.default
      })); // todo this report is broken, removed from StudySideBar currently

      dataAnalystRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "ad hoc query",
        exact: true,
        path: "/study/:studyId/adHocQuery",
        component: _AdHocQueryLandingPage.default
      }));
    }

    fullPrivilegeRoutes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "settings",
      exact: true,
      path: "/study/:studyId/settings",
      component: _SettingsLandingPage.default
    }));
    return /*#__PURE__*/_react.default.createElement(_layout.default, {
      style: {
        minHeight: '100vh'
      }
    }, /*#__PURE__*/_react.default.createElement(_StudySideBar.default, null), /*#__PURE__*/_react.default.createElement(_layout.default, {
      id: "main"
    }, /*#__PURE__*/_react.default.createElement(_Header.default, null, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        paddingLeft: '10px',
        fontSize: '25px'
      }
    }, study === null || study === void 0 ? void 0 : study.name)), /*#__PURE__*/_react.default.createElement(Content, {
      id: "content",
      style: {
        height: '100vh - 70px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: '1 1 auto',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, fullPrivilegeRoutes, dataAnalystRoutes, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "forums",
      path: "/study/:studyId/forums",
      component: _ForumPage.default
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "notFound",
      component: _StudyNotFound.default
    })))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  requestedStudyId: selectors.getRequestedStudyId,
  study: selectors.getRequestedStudy,
  status: selectors.loadStudyStatus,
  resourceTopics: selectors.getResourceTopics,
  isNonYAB: selectors.isNonYAB,
  hasDataAnalystRole: selectors.hasDataAnalystRole,
  hasStudyManagerRole: selectors.hasStudyManagerRole,
  showGoals: selectors.getGoalSettingFeatureEnabled,
  showIncentives: selectors.getIncentivesFeatureEnabled,
  showForms: selectors.getFormsFeatureEnabled,
  showSurveys: selectors.getSurveysFeatureEnabled,
  showTestKits: selectors.getTestKitsFeatureEnabled,
  showAppointments: selectors.getAppointmentsFeatureEnabled,
  showAppointmentAvailability: selectors.getAppointmentAvailabilityFeatureEnabled
});

const mapDispatchToProps = dispatch => {
  return {
    loadStudy: studyId => dispatch(_study.loadStudyAsync.request(studyId)),
    loadForumTopics: forumId => dispatch(_topic.loadForumTopicsAsync.request(forumId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StudyRouter);

exports.default = _default;